import { render } from "./EtatChiffreAffaireClientPage.vue?vue&type=template&id=91d6def2&ts=true"
import script from "./EtatChiffreAffaireClientPage.vue?vue&type=script&lang=ts"
export * from "./EtatChiffreAffaireClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__